<template>
  <div class="wxlogin">
    <div class="pop" v-if="lodingshow"> <van-loading type="spinner" /></div>
  </div>

</template>

<script>
  import Bus from '../../../static/js/bus.js'
  export default {
    name: "index",
    data () {
      return {
        lodingshow: true,
        token:this.$route.query.token,
      }
    },

    methods: {
      goBack: function () {
        history.back(-1);
      },
      godetail:function (id) {
        this.$router.push({path:'/goodslist/goods',query:{id:id}})
      },
      getCode: function () {
            localStorage.setItem("BLHuser",this.token);
            var url=localStorage.getItem("routerUrl");
            this.$store.commit('userInfo');
            if(url!=undefined && url!=null &&url!=''){
              this.$router.push({ name: url,params:{isAuth:true} })//跳到路由拦截前的地址
            }else{
              this.$router.push({ name: 'Home',params:{isAuth:true} })
            }
        // var mallid=localStorage.getItem("mallid");
        // this.$api.post('user/wechat/login2',{id_example:mallid,id:this.id}, res => {
        //   if (res.data.code == '100') {
        //     localStorage.setItem("BLHuser",res.data.data.token_user);
        //     var url=localStorage.getItem("routerUrl");
        //     this.$store.commit('userInfo');
        //     if(url!=undefined && url!=null &&url!=''){
        //       this.$router.push({ name: url,params:{isAuth:true} })//跳到路由拦截前的地址
        //     }else{
        //       this.$router.push({ name: 'Home',params:{isAuth:true} })
        //     }
        //   }
        // })
      },
    },
    created(){

    },
    mounted () {
      this.getCode()
    },
  }
</script>

<style lang="less">
  .wxlogin {

    .pop{
      background-color: #fff!important;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      .van-loading{
        position: absolute;
        top:50%;
        left: 50%;
        margin: -15px 0 0 -15px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/login/wxlogin.vue